import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'System Settings|Tagging|Tagging Items|Tag Items Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Tagging,
	portal: 'SP',
};

type LocNameStart = 'SPTagItemModal';
export type SPTagItemModalLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}ButtonUseExistingTag`
	| `${LocNameStart}ButtonAddNewTag`
	| `${LocNameStart}LabelTagName`
	| `${LocNameStart}ErrorTagNameRequired`
	| `${LocNameStart}LabelNewTagName`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonTagItems`
	| `${LocNameStart}NotificationSuccess`;

export const spTagItemModalLocs: LocDefs<SPTagItemModalLocNames> = {
	SPTagItemModalTitle: {
		defaultValue: 'Tag Items',
		description: 'Modal title.',
		displayPath: `${pathStart}Modal Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.Title.TagItems',
		...sharedProperties,
	},
	SPTagItemModalButtonUseExistingTag: {
		defaultValue: 'Use Existing Tag',
		description: 'Use existing tag button.',
		displayPath: `${pathStart}Use Existing Tag`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.Button.UseExistingTag',
		...sharedProperties,
	},
	SPTagItemModalButtonAddNewTag: {
		defaultValue: 'Add New Tag',
		description: 'Add new tag button.',
		displayPath: `${pathStart}Add New Tag`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.Button.AddNewTag',
		...sharedProperties,
	},
	SPTagItemModalLabelTagName: {
		defaultValue: 'Tag Name',
		description: 'Label for: Tag Name.',
		displayPath: `${pathStart}Tag Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.FieldLabel.TagName',
		...sharedProperties,
	},
	SPTagItemModalErrorTagNameRequired: {
		defaultValue: 'Tag Name is required',
		description: 'Error when tag name is required',
		displayPath: `${pathStart}Tag Name Required`,
		displayType: 'Error',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.FieldError.TagNameRequired',
		...sharedProperties,
	},
	SPTagItemModalLabelNewTagName: {
		defaultValue: 'New Tag Name',
		description: 'Label for: New Tag Name.',
		displayPath: `${pathStart}New Tag Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.FieldLabel.NewTagName',
		...sharedProperties,
	},
	SPTagItemModalButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button.',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		// legacyName: 'Tagging/Tagging/SystemSettings.Tagging.TagItemModal.Button.Cancel',
		...sharedProperties,
	},
	SPTagItemModalButtonTagItems: {
		defaultValue: 'Tag Items',
		description: 'Tag Items button.',
		displayPath: `${pathStart}Tag Items Button`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.Tagging.TagItemModal.Button.TagItems',
		...sharedProperties,
	},
	SPTagItemModalNotificationSuccess: {
		defaultValue: 'Changes saved',
		description: 'Notification message shown when the tag has been updated',
		displayPath: `${pathStart}Changes Saved`,
		displayType: 'Notification',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.NotificationMessage.Success',
		...sharedProperties,
	},
};

export type SPTagItemModalLocType = LocMap<SPTagItemModalLocNames>;
